var generateUniqueId = function generateUniqueId() {
  return "info-underline-".concat(Math.random().toString(36).substr(2, 9));
};

export { generateUniqueId };
